import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import copy from 'copy-to-clipboard';
import { NotificationManager } from 'react-notifications';

export default class CustomApprovalLinkModalComponent extends React.Component {
  static propTypes = {
    entity: PropTypes.any.isRequired,
    showModal: PropTypes.bool.isRequired,
    hideModal: PropTypes.func.isRequired,
    approvalRequestId: PropTypes.string.isRequired,
  };

  initializeLink = () => {
    return `${process.env.NX_REACT_APP_APPROVALS_APP_URL}/${this.props.approvalRequestId}`;
  };

  hide = () => this.props.hideModal();

  render() {
    const { entity } = this.props;
    return (
      <Modal
        title="Customer Approval Link"
        show={this.props.showModal}
        showCancel={true}
        onCancel={this.hide}
        closeOnOk={false}
        onShowUpdated={(showModal) => {
          if (!showModal) this.hide();
        }}
        cancelTitle="Close"
        showOk={false}
        onOk={() => null}
        size="lg"
      >
        {`Use the link below to acces the Customer Approval website for Order ${entity.workOrderNumber}`}
        <div className="row">
          <div className="col-10">
            <FormInput
              label=""
              autoFocus
              id="link"
              value={this.initializeLink()}
              disabled={true}
            />
          </div>
          <div className="col-2">
            <i
              id="linkCopy"
              className="fa fa-copy text-primary mt-2"
              onClick={() => {
                copy(this.initializeLink());
                NotificationManager.success(
                  `Copied approval link to clipboard`
                );
              }}
              style={{ cursor: 'pointer' }}
            />
          </div>
        </div>
      </Modal>
    );
  }
}
